<script lang="ts">
	//Types
	import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
	import { onDestroy, onMount } from 'svelte';

	export let alarm: IAlarmZone = {};
	export let time: number | undefined;

	const TIMER_INTERVAL = 1000;
	let interval: NodeJS.Timeout;

	const onClearInterval = () => {
		clearInterval(interval);
		interval = undefined;
		time = undefined;
	};

	const calcAlarmCountDown = (alarm: IAlarmZone) => {
		if (!alarm?._meta?._time_trigger) {
			onClearInterval();
			return 0;
		}

		const now = Date.now();
		const delayTime = alarm._enable_delay;
		const startTime = alarm._meta._time_trigger;
		const endTime = Math.round(startTime + delayTime);
		const remainTime = Math.round(endTime - now);
		const currentTimer = Math.round(remainTime / TIMER_INTERVAL);

		if (currentTimer <= 0) {
			onClearInterval();
			return 0;
		}

		return currentTimer;
	};

	const startCountDown = (alarm: IAlarmZone) => {
		if (interval && alarm._meta._time_trigger) return;
		time = calcAlarmCountDown(alarm);
		interval = setInterval(() => {
			//Update timer every second
			time = calcAlarmCountDown(alarm);
		}, TIMER_INTERVAL);
	};

	const isActiveCountDown = (alarm: IAlarmZone) => {
		return alarm._meta._time_trigger && alarm._enabled && alarm._enable_delay;
	};

	onMount(() => {
		if (isActiveCountDown(alarm)) {
			time = calcAlarmCountDown(alarm);
		}
	});

	onDestroy(() => {
		if (interval) {
			onClearInterval();
		}
	});

	$: showCountDown = isActiveCountDown(alarm);

	$: showCountDown ? startCountDown(alarm) : null;
</script>
